<template>
<el-popover
    :title="$t('message.notice.message')"
    width="306"
    v-model="showNoticePopover"
    popper-class="notice-popover"
    placement="bottom-end"
    :visible-arrow="false"
    trigger="click">
  <div slot="reference" class="notice-wrap">
    <div class="icon-notice">
      <el-badge class="notice-badge" :hidden="!app.showNoticeList.length" :value="app.showNoticeList.length">
        <i class="iconfont icon-xiaoxizhongxin"></i>
      </el-badge>
    </div>
  </div>
  <div class="notice-content">
    <template v-if="app.showNoticeList.length > 0">
      <div v-for="(item) in app.showNoticeList" :key="item.id" class="notice-content-item" @click="handleNoticeItem(item)">
        <p class="item-title">{{item.title}}</p>
        <p class="item-content">{{item.content}}</p>
      </div>
    </template>
    <template v-if="app.showNoticeList.length === 0">
      <empty-component :empty-subtitle="$t('message.tableCommon.searcnEmpty')"></empty-component>
    </template>
  </div>
  <el-button size="small" type="primary" class="btn-download-center" @click="handleNoticeCenter">{{$t("message.notice.noticeCenter")}}</el-button>
</el-popover>
</template>
<script>
import { mapGetters } from 'vuex';

import EmptyComponent from '@/components/table/empty-component.vue';

export default {
  components: {
    EmptyComponent,
  },
  data() {
    return {
      showNoticePopover: false,
      noticeList: [],
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  created() {
    // 获取未读消息
    this.$store.dispatch('app/refreshNotice');
  },
  methods: {
    handleNoticeCenter() {
      this.showNoticePopover = false;
      this.$router.push({ path: '/content/notice/list' });
    },
    handleNoticeItem(item) {
      this.showNoticePopover = false;
      this.$router.push({ path: '/content/notice/detail', query: { id: item.id } });
    },
  },
};
</script>
<style lang="scss" scope>
@import '@/styles/element-variables.scss';
.notice-wrap {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 35px;

  &:hover, &:active {
    background-color: #F4F6F8;
  }
}
.icon-notice {
  cursor: pointer;
  color: $color-primary;
}

.notice-content {
  min-height: 60px;
  margin-bottom: 9px;
  min-height: 185px;
  .notice-content-item {
    padding: 0 12px;
    height: 54px;
    cursor: pointer;
    margin-bottom: 8px;
    font-size: 14px;
    font-family: AvenirNext-Regular, AvenirNext;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    .item-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .item-content {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:hover {
      background-color: #F4F6F8;
    }
  }
}

.btn-download-center {
  width: 100%;
  justify-content: flex-start !important;
}
</style>
<style lang="scss">
.notice-popover {
  margin-top: 5px !important;
  padding: 4px 12px 10px 12px !important;

  .el-popover__title {
    font-size: 14px;
    font-family: Avenir-Book, Avenir;
    font-weight: normal;
    color: rgba(0,32,63,0.6);
    line-height: 30px;
    margin: 0;
    padding-left: 12px;
  }
}

.notice-badge {
  .el-badge__content {
    width: 15px;
    height: 15px;
    background: #0094C6;
    line-height: 15px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media screen and (max-width: 992px) {
  .notice-wrap {
    margin-right: 13px;
    width: inherit;
  }
  .icon-notice {
    .iconfont {
      font-size: 14px;
    }
  }
}
</style>
